import React from 'react';

import CmsIconSelector from 'components/cms/settings/components/CmsIconSelector';
import CmsTextColorSelector from 'components/cms/settings/components/CmsTextColorSelector';

import FormInput from 'components/forms/FormInput';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormRadio from 'components/forms/FormRadio';

export default class CmsElementBlurb extends React.Component {
  render() {
    const {
      intl: { messages },
      setParam,
      getParamValue,
      navigateBack,
    } = this.props;

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>Blurb</b>
        </div>

        <div className="form-group-attached">
          <FormRadio
            label={messages.image_position}
            options={[{ label: messages.position_top, value: 'top' }, { label: messages.position_left, value: 'left' }]}
            onChange={setParam}
            value={getParamValue('imagePosition', 'top')}
            name="imagePosition"
          />
          <CmsIconSelector label={messages.icon} {...this.props} />
          <CmsTextColorSelector label={messages.text_color} {...this.props} />
          <FormInput label={messages.title} name="title" onChange={setParam} value={getParamValue('title')} />
          <FormRichEditor
            label={messages.content}
            name="content"
            onChange={setParam}
            value={getParamValue('content')}
          />
        </div>
      </>
    );
  }
}
